import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-mobile-writing',
  templateUrl: './mobile-writing.component.html',
  styleUrls: ['./mobile-writing.component.scss']
})
export class MobileWritingComponent {

  @ViewChild('content') content: ElementRef;

  constructor(private modalService: NgbModal) { }

  public open() {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      windowClass: 'full-modal m-writing',
    };

    this.modalService.open(this.content, modalOptions);
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-writing/mobile-writing.component.ts